export const NUMBER_OF_PRODUCT_TO_PREVIEW = 3;
